/**
 * [TD-89 v2 Verdict Y.A] Reusable CPU identity pill.
 *
 * Single source of truth - mounts wherever a manager identity renders.
 * Theme-aware via `isDark` prop.
 */
import { Cpu } from "lucide-react";

export default function CpuBadge({ isDark, size = "sm", testId = "cpu-badge" }) {
  const sizeCls =
    size === "lg" ? "text-xs px-2 py-1 gap-1.5"
    : size === "md" ? "text-[10px] px-2 py-0.5 gap-1"
    : "text-[9px] px-1.5 py-0.5 gap-1";
  const icon = size === "lg" ? 12 : size === "md" ? 10 : 9;
  const cls = isDark
    ? "bg-[#FF6B00]/15 text-[#FF8533] border border-[#FF6B00]/30"
    : "bg-[#FF6B00]/10 text-[#FF6B00] border border-[#FF6B00]/30";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full font-display font-black uppercase tracking-wider ${sizeCls} ${cls}`}
      title="CPU-controlled team"
    >
      <Cpu size={icon} />
      CPU
    </span>
  );
}
